import { apiRouter } from '$domain/model/apiRouter'
import familiadosApiClient from '$utils/familiadosApiClient'
import { apiErrorService } from '$utils/services/apiErrorService'
import { mapProfessionalSelectionSearchServiceList } from './professionalSelectionSearch.mapper'
import {
  ProfessionalSelectionSearchService,
  ProfessionalSelectionSearchServiceDto,
} from './professionalSelectionSearch.model'

const findProfessionalSelectionSearchServiceList = async (
  searchTerm: string,
): Promise<ProfessionalSelectionSearchService[]> => {
  try {
    const serviceListDto = await familiadosApiClient.get<ProfessionalSelectionSearchServiceDto[]>(
      apiRouter.getProfessionalServiceSearchServiceListPath(),
      { offset: 0, limit: 50, searchTerm },
    )
    return mapProfessionalSelectionSearchServiceList(serviceListDto)
  } catch (error) {
    throw apiErrorService.handleError(error)
  }
}

export const professionalSelectionSearchManager = {
  findProfessionalSelectionSearchServiceList,
}



// WEBPACK FOOTER //
// ./src/domain/model/nursingHome/professionalSelection/professionalSelectionSearch/professionalSelectionSearch.manager.ts